import React from 'react';
import { Button, Modal, Typography } from '@riac/design-system';

interface ISuggestedAddressModal {
  original: {
    name?: string,
    address1: string,
    address2?: string,
    city: string,
    state: string|React.Key,
    zipCode: string,
  };
  suggested: {
    sugName?: string,
    sugAddr2?: string,
    sugAddr1: string,
    sugCity: string,
    sugState: string,
    sugZip4: string,
    sugZip5: string,
  };
  selectOriginal(): void;
  selectSuggested(): void;
  cancel(): void;
  children?: React.ReactNode;
  open?: boolean;
}

export const SuggestedAddressModal = ({
  original,
  suggested,
  selectOriginal,
  selectSuggested,
  cancel,
  children,
  open,
}: ISuggestedAddressModal) => {
  return (
    <Modal
      isOpen={open ?? true}
      isDismissable
      showCloseButton
      onClose={() => cancel()}
      title='Confirm Address'
      footerButtons={<div className='grid grid-cols-2 gap-3 w-full'>
        <Button size='lg' variant='secondary' onPress={selectOriginal}>Use Original</Button>
        <div className='flex flex-col gap-3 items-stretch justify-between'>
          <Button size='lg' onPress={selectSuggested}>Use Suggested</Button>
        </div>
      </div>}
    >
      {children}
      <div className='grid sm:grid-cols-2 gap-3'>
        <div>
          <Typography weight='medium'>You Entered:</Typography>
          {original.name && <p>{original.name}</p>}
          <p>{original.address1}</p>
          {original.address2 && <p>{original.address2}</p>}
          <p>
            {original.city}, {original.state} {original.zipCode}
          </p>
        </div>
        <div>
          <Typography weight='medium'>Suggested Address:</Typography>
          {suggested.sugName && <p>{suggested.sugName}</p>}
          <p>{suggested.sugAddr1}</p>
          {suggested.sugAddr2 && <p>{suggested.sugAddr2}</p>}
          <p>
            {suggested.sugCity}, {suggested.sugState} {suggested.sugZip5}-{suggested.sugZip4}
          </p>
        </div>
      </div>
    </Modal>
  );
};
